/* Putter Fit Quiz — logic ported 1:1 from the Daytona Beach fit tool, plus Shopify cart wiring */
(function () {
  'use strict';

  /* ---------- Option icons (same as the HTML tool) ---------- */
  var S = 'stroke="currentColor" fill="none" stroke-width="2.2" stroke-linecap="round"';
  var ICON = {
    strong:   '<svg viewBox="0 0 44 44" aria-hidden="true"><path ' + S + ' d="M8 30 Q22 14 36 30"/><circle cx="22" cy="22" r="2.6" fill="currentColor"/></svg>',
    slight:   '<svg viewBox="0 0 44 44" aria-hidden="true"><path ' + S + ' d="M8 27 Q22 21 36 27"/><circle cx="22" cy="24" r="2.6" fill="currentColor"/></svg>',
    straight: '<svg viewBox="0 0 44 44" aria-hidden="true"><path ' + S + ' d="M8 24 H36"/><circle cx="22" cy="24" r="2.6" fill="currentColor"/></svg>',
    unsure:   '<svg viewBox="0 0 44 44" aria-hidden="true"><path ' + S + ' d="M16 16 Q16 9 22 9 Q28 9 28 15 Q28 20 22 22 V27"/><circle cx="22" cy="34" r="1.8" fill="currentColor"/></svg>',
    dot:      '<svg viewBox="0 0 44 44" aria-hidden="true"><rect x="6" y="14" width="32" height="16" rx="3" ' + S + '/><circle cx="22" cy="22" r="2.4" fill="currentColor"/></svg>',
    line:     '<svg viewBox="0 0 44 44" aria-hidden="true"><rect x="6" y="14" width="32" height="16" rx="3" ' + S + '/><path ' + S + ' d="M15 22 H29"/></svg>',
    tee:      '<svg viewBox="0 0 44 44" aria-hidden="true"><rect x="6" y="14" width="32" height="16" rx="3" ' + S + '/><path ' + S + ' d="M11 17 V27 M11 22 H33"/></svg>'
  };

  /* ---------- Questions + scoring weights (edit here) ---------- */
  var QUESTIONS = [
    { id: 'stroke', q: 'Picture your stroke from above. What shape does the putter head travel?',
      help: 'Think about your normal stroke on a 10-foot putt.', cols: true,
      options: [
        { v: 'strong',   label: 'Moderate-to-strong arc', sub: 'Swings noticeably inside going back and through', base: 1.5, icon: ICON.strong },
        { v: 'slight',   label: 'Slight-to-moderate arc', sub: 'A gentle curve, a little inside',                  base: 2.5, icon: ICON.slight },
        { v: 'straight', label: 'Mostly straight', sub: 'Straight back and straight through',              base: 4.5, icon: ICON.straight },
        { v: 'unsure',   label: 'Not sure',        sub: 'We’ll use your other answers',                     base: 3, icon: ICON.unsure }
      ] },
    { id: 'feel', q: 'Through impact, what do you want the putter face to do?',
      help: 'Go with what feels natural, not what you think is correct.',
      options: [
        { v: 'release', label: 'Feel it release',       sub: 'I like to feel the face turn through the ball', shift: -0.25 },
        { v: 'neutral', label: 'No strong preference',  sub: 'Either feels fine to me',                        shift: 0 },
        { v: 'square',  label: 'Keep it square',        sub: 'I want the face to stay stable and quiet',       shift: 0.25 }
      ] },
    { id: 'miss', q: 'When you miss your line, which happens more often?',
      help: 'For right-handed golfers, a pull starts left of the target and a push starts right.',
      options: [
        { v: 'pull', label: 'Pulls',          sub: 'The ball starts left of my line',  shift: -0.75 },
        { v: 'push', label: 'Pushes',         sub: 'The ball starts right of my line', shift: 0.75 },
        { v: 'none', label: 'No real pattern', sub: 'My misses are mostly speed',       shift: 0 }
      ] },
    { id: 'look', q: 'What do you like to see behind the ball at address?',
      help: 'This helps us choose between close matches.',
      options: [
        { v: 'minimal', label: 'A clean, minimal look', sub: 'A single dot, nothing more',                 shift: -0.4, pref: 1, icon: ICON.dot },
        { v: 'line',    label: 'A simple line',         sub: 'Enough to aim with, without much clutter',   shift: 0,    pref: 2.5, icon: ICON.line },
        { v: 'strong',  label: 'Strong lines',          sub: 'Lines that frame the ball and the face',     shift: 0.4,  pref: 4.5, icon: ICON.tee }
      ] }
  ];
  var LABELS = ['Your best fit', 'Strong match', 'Also consider'];
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Tracking → Shopify Customer events (custom pixel forwards to GA4) ---------- */
  var QUIZ = 'concept59_daytona';
  function pfqTrack(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish(name, Object.assign({ quiz: QUIZ }, data || {}));
      }
    } catch (e) {}
    pfqClarity(name, data || {});
  }

  /* ---------- Microsoft Clarity (runs on the page, so it lives here, not in the custom pixel) ---------- */
  function clarity() {
    try { if (typeof window.clarity === 'function') window.clarity.apply(null, arguments); } catch (e) {}
  }
  function pfqClarity(name, d) {
    if (name === 'c59_lp_view') {
      clarity('set', 'quiz', QUIZ);
      clarity('event', 'c59_lp_view');
    } else if (name === 'c59_quiz_engaged') {
      clarity('event', 'quiz_engaged');
    } else if (name === 'c59_quiz_complete') {
      clarity('set', 'quiz_result', d.result || '');
      clarity('event', 'quiz_complete');
    } else if (name === 'c59_result_click') {
      clarity('set', 'quiz_result_clicked', d.item_name || '');
      clarity('event', 'quiz_result_click');
    }
  }

  function init(el) {
    var putters = JSON.parse(el.querySelector('[data-pfq-putters]').textContent).map(function (p) {
      p.align = (p.align || '').trim().replace(/\.+$/, '');   // no trailing period → avoids ".."
      p.specList = (p.specs || '').split('\n').map(function (l) {
        var i = l.indexOf(':'); return i > -1 ? [l.slice(0, i).trim(), l.slice(i + 1).trim()] : null;
      }).filter(Boolean);
      return p;
    });
    var noteTpl = el.querySelector('[data-pfq-note]');
    var track = el.querySelector('[data-pfq-track]');
    var backBtn = el.querySelector('[data-pfq-back]');
    var segs = el.querySelectorAll('.pfq__seg');
    var tTitle = el.querySelector('[data-pfq-title]');
    var tCount = el.querySelector('[data-pfq-count]');
    var introText = tTitle.textContent;
    var answers = {}, step = 0, last = null, engaged = false;
    pfqTrack('c59_lp_view');

    /* Quiz engaged = first interaction anywhere inside the quiz (once per page load) */
    function onEngage() {
      if (engaged) return;
      engaged = true;
      el.removeEventListener('click', onEngage, true);
      el.removeEventListener('keydown', onEngage, true);
      pfqTrack('c59_quiz_engaged');
    }
    el.addEventListener('click', onEngage, true);
    el.addEventListener('keydown', onEngage, true);

    /* Build question panels */
    QUESTIONS.forEach(function (qq, i) {
      var panel = document.createElement('section');
      panel.className = 'pfq__panel';
      var id = el.id + '-q' + i;
      var html = '<h3 class="pfq__q" id="' + id + '">' + qq.q + '</h3><p class="pfq__help">' + qq.help + '</p>' +
        '<div class="pfq__options' + (qq.cols ? ' pfq__options--cols' : '') + '" role="group" aria-labelledby="' + id + '">';
      qq.options.forEach(function (o) {
        html += '<button class="pfq__opt" type="button" aria-pressed="false" data-q="' + qq.id + '" data-v="' + o.v + '">' + (o.icon || '') +
          '<span><span class="pfq__opt-label">' + o.label + '</span><span class="pfq__opt-sub">' + o.sub + '</span></span></button>';
      });
      panel.innerHTML = html + '</div>';
      track.appendChild(panel);
    });
    var resultPanel = document.createElement('section');
    resultPanel.className = 'pfq__panel';
    track.appendChild(resultPanel);
    var panels = track.querySelectorAll('.pfq__panel');

    track.addEventListener('click', function (e) {
      var res = e.target.closest('[data-c59-result]');
      if (res) {
        pfqTrack('c59_result_click', {
          item_name: res.getAttribute('data-c59-result'),
          item_id: res.getAttribute('data-c59-id') || '',
          rank: Number(res.getAttribute('data-c59-rank')) || 0,
          link_type: res.getAttribute('data-c59-link') || ''
        });
        return;   // let the link navigate normally
      }
      var btn = e.target.closest('.pfq__opt');
      if (btn) {
        answers[btn.dataset.q] = btn.dataset.v;
        btn.parentNode.querySelectorAll('.pfq__opt').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        setTimeout(function () { goTo(step + 1); }, 320);
        return;
      }
      if (e.target.closest('[data-pfq-restart]')) restart();
    });
    backBtn.addEventListener('click', function () { goTo(step - 1); });

    function goTo(n, initial) {
      var before = el.getBoundingClientRect().top;
      step = Math.max(0, Math.min(n, QUESTIONS.length));
      if (step === QUESTIONS.length) renderResults();
      track.style.transform = 'translateX(' + (-step * 100) + '%)';
      panels.forEach(function (p, i) { p.setAttribute('aria-hidden', i === step ? 'false' : 'true'); });
      segs.forEach(function (s, i) { s.classList.toggle('is-done', i < step); });
      var done = step === QUESTIONS.length;
      tTitle.textContent = done ? 'Your fit is ready' : introText;
      tCount.textContent = done ? '4 of 4 answered' : 'Question ' + (step + 1) + ' of 4';
      backBtn.hidden = step === 0;
      backBtn.textContent = done ? 'Go back and change an answer' : 'Go back';
      if (initial) return;
      /* move focus into the new panel WITHOUT letting the browser scroll to it */
      var focusEl = panels[step].querySelector('.pfq__opt[aria-pressed="true"]') || panels[step].querySelector('.pfq__opt, .pfq__q');
      if (focusEl) { if (!focusEl.hasAttribute('tabindex') && !focusEl.matches('button')) focusEl.setAttribute('tabindex', '-1'); focusEl.focus({ preventScroll: true }); }
      lockView(before);
    }

    /* ---------- Keep the page locked on the Q&A ---------- */
    function lockView(before) {
      requestAnimationFrame(function () {
        /* 1) undo any jump caused by layout / focus changes */
        var diff = el.getBoundingClientRect().top - before;
        if (diff) window.scrollBy(0, diff);
        /* 2) if the progress bar is off-screen (or too low), bring it to the top */
        var tracker = el.querySelector('.pfq__tracker');
        var t = tracker.getBoundingClientRect().top;
        var offset = parseInt(getComputedStyle(tracker).scrollMarginTop, 10) || 0;
        if (t < offset || t > window.innerHeight * 0.4) {
          window.scrollTo({ top: window.pageYOffset + t - offset, behavior: 'smooth' });
        }
      });
    }

    function opt(qid) {
      var q = QUESTIONS.filter(function (x) { return x.id === qid; })[0];
      return q.options.filter(function (o) { return o.v === answers[qid]; })[0];
    }

    /* ---------- Scoring (same as original) ---------- */
    function score() {
      var target = opt('stroke').base + opt('feel').shift + opt('miss').shift + opt('look').shift;
      target = Math.max(1, Math.min(5, target));
      var pref = opt('look').pref;
      var ranked = putters.map(function (p) {
        return { p: p, d: Math.abs(p.pos - target) + 0.15 * Math.abs(p.look - pref) / 4 };
      }).sort(function (a, b) { return a.d - b.d; });
      return { target: target, top: ranked.slice(0, 3).map(function (r) { return r.p; }) };
    }

    /* ---------- Explanations (same as original) ---------- */
    function lookLevel(p) { return p.look === 1 ? 'minimal' : (p.look <= 3 ? 'line' : 'strong'); }
    var LV = { minimal: 1, line: 2, strong: 3 };

    function whyBest(p) {
      var parts = [];
      var lead = {
        strong: 'Your stroke swings on a strong arc',
        slight: 'Your stroke has a slight arc',
        straight: 'Your stroke moves mostly straight back and through',
        unsure: 'Based on how you described your feel and your miss'
      }[answers.stroke];
      parts.push(lead + ', and the ' + p.name + '’s ' + p.neck + ' is built ' + (/^to /.test(p.rotation) ? '' : 'for ') + p.rotation + '.');
      var conflict = (answers.feel === 'square' && answers.miss === 'pull') || (answers.feel === 'release' && answers.miss === 'push');
      var C = p.copy || {};
      if (!conflict && answers.feel === 'release') parts.push(C.release || 'You like to feel the face release, so we leaned slightly toward a head that rotates.');
      if (!conflict && answers.feel === 'square') parts.push(C.square || 'You want the face to feel stable through impact, so we leaned slightly toward lower rotation.');
      if (answers.miss === 'pull') parts.push(C.pull || 'To help counter your pull, your fit moves toward more toe hang. For most golfers, a toe-hang putter opens a little more on the backstroke, so the face starts the through stroke from a more open position and is less likely to be closed at impact.');
      if (answers.miss === 'push') parts.push(C.push || 'To help counter your push, your fit moves toward less toe hang. For most golfers, a lower-rotation head opens less on the backstroke, so the face arrives slightly less open at impact.');
      var want = answers.look, have = lookLevel(p);
      if (want === have) parts.push(C.lookMatch || 'You also get the look you prefer: ' + p.align + '.');
      else parts.push('It features ' + p.align + ', which gives you ' + (LV[have] > LV[want] ? 'more' : 'less') +
        ' visual structure than you said you like. That pairing is intentional: each Daytona Beach neck is matched to the alignment that complements how it rotates.');
      return parts.join(' ');
    }

    function whyAlt(p, best) {
      var rel = 'A step toward ' + (p.pos > best.pos ? 'less' : 'more') + ' rotation than your best fit, with ' + p.align + '.';
      if (answers.look === lookLevel(p) && answers.look !== lookLevel(best)) rel += ' It’s the closest match to the look you prefer.';
      return rel + ' ' + p.who;
    }

    /* ---------- Results ---------- */
    function renderResults() {
      var r = score(), best = r.top[0];
      last = r;
      var picked = r.top.map(function (p) { return p.key; });
      var stops = putters.slice().sort(function (a, b) { return a.pos - b.pos; }).map(function (p) {
        return '<div class="pfq__stop' + (picked.indexOf(p.key) > -1 ? ' is-pick' : '') + '">' + p.name.replace('Daytona Beach ', '') + '</div>';
      }).join('');

      var items = r.top.map(function (p, i) {
        var specs = p.specList.map(function (s) { return '<li>' + s[0] + ' <b>' + s[1] + '</b></li>'; }).join('');
        var prod = p.product;
        var url = prod ? prod.url + '?fit=' + encodeURIComponent(p.key) : '';
        var tr = function (link) { return ' data-c59-result="' + p.name + '" data-c59-id="' + p.key + '" data-c59-rank="' + (i + 1) + '" data-c59-link="' + link + '"'; };
        var img = '<span></span>';
        if (prod && prod.image) {
          img = '<a class="pfq__img-link" href="' + url + '"' + tr('image') + ' aria-label="View ' + p.name + '">' +
            '<img src="' + prod.image + '" alt="' + p.name + '" loading="lazy" width="240"></a>';
        }
        var title = prod ? '<a class="pfq__title-link" href="' + url + '"' + tr('title') + '>' + p.name + '</a>' : p.name;
        var view = prod ? '<a class="pfq__view" href="' + url + '"' + tr('view_details') + '>View details</a>' : '';
        return '<article class="pfq__result' + (i === 0 ? ' is-best' : '') + '" data-key="' + p.key + '">' + img +
          '<div><div class="pfq__rank-row"><p class="pfq__rank">' + LABELS[i] + '</p>' + view + '</div><h4 class="pfq__model">' + title + '</h4>' +
          '<p class="pfq__why">' + (i === 0 ? whyBest(p) : whyAlt(p, best)) + '</p><ul class="pfq__specs">' + specs + '</ul></div></article>';
      }).join('');

      resultPanel.innerHTML =
        '<h3 class="pfq__q">Where you land on the Daytona Beach spectrum</h3>' +
        '<div class="pfq__spectrum"><div class="pfq__rail">' + stops + '<span class="pfq__marker" style="left:50%"></span></div>' +
        '<div class="pfq__ends"><span>More rotation, less alignment</span><span>Less rotation, more alignment</span></div></div>' +
        items +
        '<button class="pfq__restart" type="button" data-pfq-restart>Start over</button>' +
        (noteTpl ? '<div class="pfq__note">' + noteTpl.innerHTML + '</div>' : '');

      var pct = ((r.target - 1) / 4) * 80 + 10;
      setTimeout(function () { var mk = resultPanel.querySelector('.pfq__marker'); if (mk) mk.style.left = pct + '%'; }, 450);

      saveQuizToCart(r);   // cart attributes → order "Additional details"
      pfqTrack('c59_quiz_complete', {
        result: best.name,
        result_id: best.key,
        top_3: r.top.map(function (p) { return p.key; }).join(','),
        score: Number(r.target.toFixed(2)),
        stroke: answers.stroke, feel: answers.feel, miss: answers.miss, look: answers.look
      });
    }

    /* ---------- Data payloads ---------- */
    function quizAttributes(r) {
      return {
        'Fit quiz - stroke': answers.stroke,
        'Fit quiz - feel': answers.feel,
        'Fit quiz - miss': answers.miss,
        'Fit quiz - look': answers.look,
        'Fit quiz - score': r.target.toFixed(2),
        'Fit quiz - best fit': r.top[0].key,
        'Fit quiz - top 3': r.top.map(function (p) { return p.key; }).join(', '),
        'Fit quiz - version': el.dataset.quizVersion || ''
      };
    }

    function saveQuizToCart(r) {
      var attrs = quizAttributes(r);
      try { sessionStorage.setItem('pfq_result', JSON.stringify(attrs)); } catch (e) {}
      return fetch(ROOT + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    }

    function restart() {
      answers = {};
      track.querySelectorAll('.pfq__opt').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      goTo(0);
    }

    goTo(0, true);
  }

  function boot() { document.querySelectorAll('.pfq').forEach(function (el) { if (!el.dataset.pfqReady) { el.dataset.pfqReady = '1'; init(el); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot); // theme editor
})();